import { ApiParams } from '../../../../common/api/api';
import {
  useApiGet,
  useApiPost,
  useApiPatch,
  ApiResult,
  useApiDelete,
  FetchApiCallback
} from '../../../../common/api/Api.hooks';
import { PaginatedList } from '../../../../common/PaginatedList.interface';
import { TestStep, TestStepCreateDto } from './TestStep.interface';

export function useCreateTestStep(): [
  ApiResult<TestStep>,
  (dto: TestStepCreateDto) => void
] {
  const { post, ...result } = useApiPost<TestStep>('test-steps');
  return [result, post];
}

export function useUpdateTestStep(
  id: number
): [ApiResult<TestStep>, (dto: Partial<TestStep>) => void] {
  const { patch, ...result } = useApiPatch<TestStep>(`test-steps/${id}`);
  return [result, patch];
}

export function useUpdateManyTestSteps(): [
  ApiResult<TestStep[]>,
  (testSteps: Array<Partial<TestStep>>) => void
] {
  const { patch, ...result } = useApiPatch<TestStep[]>('test-steps/many');
  return [result, patch];
}

export function useDeleteTestStep(
  id: number | undefined
): [ApiResult<boolean>, FetchApiCallback] {
  const { del, ...result } = useApiDelete<boolean>(`test-steps/${id || 0}`);
  return [result, del];
}

export interface FindTestStepsParams extends ApiParams {
  verificationId?: number;
  validationId?: number;
}

export function useFindTestSteps(): [
  ApiResult<PaginatedList<TestStep>>,
  (params?: FindTestStepsParams) => void
] {
  const { get, ...result } = useApiGet<PaginatedList<TestStep>>('test-steps');
  return [result, get];
}

export function useFindAllTestSteps(): [
  ApiResult<TestStep[]>,
  (params?: FindTestStepsParams) => void
] {
  const { get, ...result } = useApiGet<TestStep[]>('test-steps/all');
  return [result, get];
}
